import './paymentSuccessfulRP.css'

import { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import checkMark from '../../../imgs/correct.svg'
import { setPackageForPayment } from '../../../store/packageSlice'
import TheFooter from '../TheFooter'

export default function PaymentSuccessfulRP() {
  const history = useHistory()
  const [count, setCount] = useState(5)
  let countInterval = useRef()
  let timeoutRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPackageForPayment(null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timeoutRef = setTimeout(() => {
      history.push('/personal-info/myPackages')
    }, 7000)
    countInterval.current = setInterval(() => {
      setCount(prevCount => prevCount - 1)
    }, 1000)
    return () => clearInterval(countInterval)
  }, [])

  useEffect(() => {
    if (count == 0) clearInterval(countInterval.current)
  }, [count])

  return (
    <div className='payment-successful-container'>
      <div className='ps-img-cont'>
        <img src={checkMark} alt='payment-successful' className='ps-img' />
      </div>

      <div className='ps-text'>
        <h2>התשלום בוצע בהצלחה!</h2>
        <div>
          בקשתך בטיפול.
          <br />
          לשינוי או ביטול הבקשה יש לפנות לשירות הלקוחות.
        </div>
      </div>

      <div>
        <div>בעוד {count} שניות תועבר לעמוד "החבילות שלי"</div>
        <Button
          onClick={() => {
            history.push('/personal-info/myPackages')
            clearTimeout(timeoutRef.current)
            clearInterval(countInterval.current)
          }}
          variant='outline-info'
        >
          חזרה לחבילות שלי
        </Button>
      </div>

      <TheFooter />
    </div>
  )
}
